// Dependencies
import React from "react";
import { css } from "emotion";
import { Link, withRouter } from "react-router-dom";
import { Menu as MenuAntd, Icon } from "antd";
import { configApp } from "../configApp";
import findLastMatchPath from "../lib/findLastMatchPath";
import { paths } from "../configApp";

const menuCss = `
  background-color: #455a64;
  .ant-menu-item > a {
    color: #fff !important;
  }
  .ant-menu-item:hover{
    border-color: rgb(153, 170, 0);
  }
  .ant-menu-item-selected {
    background-color: #333 !important; 
    border-color: rgb(153, 170, 0);
  }
  .ant-menu-item {
    color: red !important;
  }
`;

const renderMenu = () => {
  const renderIcon = (icon) => icon && <Icon type={icon} />;
  const renderSimpleItem = (item) => {
    return (
      <MenuAntd.Item key={item.path}>
        <Link to={item.path}>
          {renderIcon(item.icon)}
          <span>{item.label}</span>
        </Link>
      </MenuAntd.Item>
    );
  };
  return configApp.map((it) => {
    const childrenRender =
      it.children && it.children.filter((item) => !item.navPath);
    return !it.children || !childrenRender.length ? (
      renderSimpleItem(it)
    ) : (
      <MenuAntd.SubMenu
        key={`sub-${it.key}`}
        title={
          <span>
            {renderIcon(it.icon)}
            {it.label}
          </span>
        }
      >
        {it.children.map((subItem) => renderSimpleItem(subItem))}
      </MenuAntd.SubMenu>
    );
  });
};

const MainMenu = ({ history }) => {
  const simplePaths = paths.map((path) => path.path);
  const findedPath = findLastMatchPath(history.location.pathname, simplePaths);
  return (
    <MenuAntd
      className={css(menuCss)}
      mode="horizontal"
      selectedKeys={[findedPath]}
    >
      {renderMenu()}
    </MenuAntd>
  );
};

export default withRouter(MainMenu);
